import { AvailabilityHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useDropoffAvailabilities = (): AvailabilityHook => {
  const { availabilityStore } = useStore();
  const { dropoffAvailabilities, loading } = availabilityStore;

  useEffect(() => {
    availabilityStore.getDropoffAvailabilities();

    return () => availabilityStore.clearDropoffAvailabilities();
  }, [availabilityStore]);

  return {
    availabilities: Array.from(dropoffAvailabilities.values()),
    loading,
  };
};
